export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '项目订单';
